<div class="row col-sm-12" style="padding-right: 0; margin-right: 0; margin-bottom: 2rem">
  <div class="mct-flex col-sm-5 mct-row mct-items-stretch">
    <h3>{{ 'dashboard.membership-activity.title' | translate | titlecase }}</h3>
    <a *ngIf="!hideSalesOpps" href="dashboard#mySalesOpps" class="my-opps-link">{{
      'dashboard.sales-opportunities.view-button' | translate
    }}</a>
    <a *ngIf="!hideTasks" href="dashboard#myTasks" class="my-opps-link">{{ 'dashboard.tasks.view-my-tasks' | translate | titlecase }}</a>
  </div>
  <div class="col-sm-7" style="padding-right: 0; margin-right: 0; margin-bottom: 1rem">
    <div class="full-width wl-text-right" style="padding-right: 0; margin-right: 0">
      <div style="display: inline-block; padding-right: 3rem">
        <wl-date-selector name="startDate" [(ngModel)]="startDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
      </div>
      <div style="display: inline-block; padding-right: 3rem">
        <div style="display: inline-block; margin: auto 1.5rem">
          {{ 'common.through' | translate }}
        </div>
        <wl-date-selector name="endDate" [(ngModel)]="endDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
      </div>
    </div>
  </div>
</div>
<div class="col-sm-12 wl-dashboard-member-activity" style="margin-bottom: 3rem">
  <p-table [showGridlines]="true"
    #membershipActivityGrid
    [ngClass]="showMembershipActivityDetails ? 'wl-responsive-prime-datatable' : 'wl-responsive-prime-datatable body-hidden'"
    [value]="membershipActivityDetails"
    [paginator]="false"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="wl-prime-datatable-hidden-phone">
        <th style="width: 22%; text-align: left !important">
          <a
            (click)="toggleMembershipActivityDetails()"
            [ngClass]="{ 'wl-dashboard-open-close-open': showMembershipActivityDetails }"
            [hidden]="membershipActivityDetails.length == 1"
          >
            <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-up"></span>
            <ng-container *ngIf="!showMembershipActivityDetails">
              <span>{{ 'dashboard.membership-activity.show-all-levels' | translate | titlecase }}</span>
            </ng-container>
            <ng-container *ngIf="showMembershipActivityDetails">
              <span>{{ 'dashboard.membership-activity.show-totals-only' | translate | titlecase }}</span>
            </ng-container>
          </a>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.new-members' | translate | titlecase }}</span>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.new-investment' | translate | titlecase }}</span>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.dropped-members' | translate | titlecase }}</span>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.lost-investment' | translate | titlecase }}</span>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.gain-loss' | translate | titlecase }}</span>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.gain-loss-investment' | translate | titlecase }}</span>
        </th>
        <th>
          <span>{{ 'dashboard.membership-activity.total-members' | translate | titlecase }}</span>
        </th>
      </tr>
      <tr class="wl-prime-datatable-hidden-tablet-and-bigger">
        <th style="text-align: left !important">
          <a (click)="toggleMembershipActivityDetails()" [ngClass]="{ 'wl-dashboard-open-close-open': showMembershipActivityDetails }">
            <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-down"></span>
            <span *ngIf="!showMembershipActivityDetails">
              &nbsp;{{ 'dashboard.membership-activity.show-all-levels' | translate | titlecase }}
            </span>
            <span *ngIf="showMembershipActivityDetails">
              &nbsp;{{ 'dashboard.membership-activity.show-totals-only' | translate | titlecase }}
            </span>
          </a>
        </th>
      </tr>
    </ng-template>
    <ng-template let-level pTemplate="body">
      <tr class="wl-prime-datatable-hidden-phone" [hidden]="!showMembershipActivityDetails">
        <td style="text-align: left !important">
          {{ level.MembershipLevel }}
        </td>
        <td>
          {{ level.NewMembers }}
        </td>
        <td>
          {{ level.NewInvestment | currency }}
        </td>
        <td>
          {{ level.DroppedMembers }}
        </td>
        <td>
          {{ level.LostInvestment | currency }}
        </td>
        <td>
          {{ level.GainLoss | negativeParens }}
        </td>
        <td>
          {{ level.GainLossInvestment | currency }}
        </td>
        <td>
          {{ level.TotalMembers }}
        </td>
      </tr>
      <tr class="wl-prime-datatable-hidden-tablet-and-bigger" [hidden]="!showMembershipActivityDetails">
        <td style="text-align: left !important">
          <h4>{{ level.MembershipLevel }}</h4>
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-members' | translate | titlecase }}: </span>&nbsp;&nbsp;{{
            level.NewMembers
          }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-investment' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ level.NewInvestment | currency }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.dropped-members' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ level.DroppedMembers }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.lost-investment' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ level.LostInvestment | currency }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.gain-loss' | translate | titlecase }}: </span>&nbsp;&nbsp;{{
            level.GainLoss | negativeParens
          }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.gain-loss-investment' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ level.GainLossInvestment | currency }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.total-members' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ level.TotalMembers }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr class="wl-prime-datatable-hidden-phone footer">
        <td style="text-align: left !important">
          <span>{{ 'dashboard.membership-activity.membership-activity-totals' | translate | titlecase }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.NewMembers }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.NewInvestment | currency }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.DroppedMembers }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.LostInvestment | currency }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.GainLoss | negativeParens }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.GainLossInvestment | currency }}</span>
        </td>
        <td>
          <span>{{ membershipActivityTotals.TotalMembers }}</span>
        </td>
      </tr>
      <tr class="wl-text-left wl-prime-datatable-hidden-tablet-and-bigger">
        <td style="text-align: left !important">
          <h4>{{ 'dashboard.membership-activity.membership-activity-totals' | translate | titlecase }}</h4>
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-members' | translate | titlecase }}: </span>&nbsp;&nbsp;{{
            membershipActivityTotals.NewMembers
          }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.new-investment' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ membershipActivityTotals.NewInvestment | currency }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.dropped-members' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ membershipActivityTotals.DroppedMembers }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.lost-investment' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ membershipActivityTotals.LostInvestment | currency }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.gain-loss' | translate | titlecase }}: </span>&nbsp;&nbsp;{{
            membershipActivityTotals.GainLoss | negativeParens
          }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.gain-loss-investment' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ membershipActivityTotals.GainLossInvestment | currency }}<br />
          <span style="font-weight: bold"> {{ 'dashboard.membership-activity.total-members' | translate | titlecase }}: </span
          >&nbsp;&nbsp;{{ membershipActivityTotals.TotalMembers }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<wl-dashboard-retention #retentionReport></wl-dashboard-retention>
<div class="col-sm-12">
  <div
    class="wl-dashboard-report-container atlas-table mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-10"
  >
    <div class="mct-flex mct-justify-start mct-items-center mct-basis-40">
      <action-button
        id="engagementReportsMenu"
        [label]="'dashboard.membership-activity.reports.engagement-reports' | translate | uppercase"
        [items]="engagementReportsItems"
      >
      </action-button>
    </div>
    <div class="mct-flex mct-row mct-wrap mct-justify-end mct-items-center mct-justify-start-lt-md mct-items-center-lt-md mct-basis-100">
      {{ 'dashboard.membership-activity.reports.title' | translate }}&nbsp;&nbsp;
      <button pButton type="button" class="btn btn-primary" (click)="openMembersJoinedReport()" icon="pi pi-chart-bar">
        {{ 'dashboard.membership-activity.reports.members-joined' | translate | titlecase }}</button
      >&nbsp;&nbsp;
      <button pButton type="button" class="btn btn-primary" (click)="openMemberRetentionReport()" icon="pi pi-chart-bar">
        {{ 'dashboard.membership-activity.reports.member-retention' | translate | titlecase }}</button
      >&nbsp;&nbsp;
      <button pButton type="button" class="btn btn-primary" (click)="openMembersDroppedReport()" icon="pi pi-chart-bar">
        {{ 'dashboard.membership-activity.reports.members-dropped' | translate | titlecase }}</button
      >&nbsp;&nbsp;
    </div>
  </div>
</div>
